import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ZikataToastService {
  toasts: any[] = [];

  showSuccess(text: string) {
    this.show(text, { classname: 'bg-success text-light', delay: 5000 });  
  }

  showError(text: string) {
    this.show(text, { classname: 'bg-danger text-light', delay: 5000 });  
  }

  showWarning(text: string) {
    this.show(text, { classname: 'bg-warning text-dark', delay: 5000 }); 
  }

  showPrimary(text: string) {
    this.show(text, { classname: 'bg-primary text-light', delay: 5000 }); 
  }

  showSecondary(text: string) {
    this.show(text, { classname: 'bg-secondary text-dark', delay: 5000 }); 
  }

  showInfo(text: string) {
    this.show(text, { classname: 'bg-info text-dark', delay: 5000 }); 
  }

  showDanger(text: string) {
    this.show(text, { classname: 'bg-danger text-light', delay: 5000 }); 
  }

  showLight(text: string) {
    this.show(text, { classname: 'bg-light text-dark', delay: 5000 }); 
  }

  showDark(text: string) {
    this.show(text, { classname: 'bg-dark text-light', delay: 5000 }); 
  }


  private show(text: string, options: any = {}) {
    this.toasts.push({ text, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}